import { Component, inject, input } from '@angular/core';
import { AutocompleteComponent } from '../autocomplete.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NoopValueAccessorDirective } from '../../noop-value-accessor.directive';
import { CustomerService } from '../../../../api/customer/customer.service';
import { Customer } from '../../../../api/customer/customer.model';
import { AutocompleteWrapper } from './autocomplete-wrapper';

@Component({
  selector: 'app-autocomplete-customer',
  standalone: true,
  imports: [AutocompleteComponent, ReactiveFormsModule],
  hostDirectives: [NoopValueAccessorDirective],
  template: `
    <app-autocomplete
      [formControl]="formControl"
      [queryFn]="queryFn"
      [displayWith]="displayWith"
      [label]="label()"
    ></app-autocomplete>
  `,
})
export class AutocompleteCustomerComponent extends AutocompleteWrapper {
  private readonly customerService = inject(CustomerService);
  label = input($localize`Customer`);

  readonly queryFn = (search: string) =>
    this.customerService.list({ search, page: { page: 0, limit: 15 } });

  readonly displayWith = (item: Customer) =>
    `${item.firstName} ${item.lastName}`;
}
